// Iter 570 — Bar filter Antrean Shopee API: mendesak global, kategori, pencarian, urutan.
import React, { useEffect, useRef, useState } from "react";
import { AlertTriangle, Search, X, SlidersHorizontal } from "lucide-react";

export function QueueFilters({ meta, category, setCategory, qInput, setQInput, sort, setSort, urgentOnly, setUrgentOnly,
  technique, setTechnique }) {
  const red = meta?.urgency_counts?.red || 0;
  const cats = meta?.categories || [];
  const counts = meta?.category_counts || {};
  const searchRef = useRef(null);
  const [open, setOpen] = useState(false);
  const techLabel = (meta?.techniques || []).find(t => t.key === technique)?.label || technique;
  const catLabel = cats.find(c => c.key === category)?.label || category;
  const nActive = (technique !== "all" ? 1 : 0) + (category !== "all" ? 1 : 0);
  useEffect(() => {  // "/" = fokus pencarian (kecuali sedang mengetik)
    const onKey = (e) => {
      if (e.key !== "/" || e.ctrlKey || e.metaKey || e.altKey) return;
      const t = e.target;
      const tag = (t?.tagName || "").toLowerCase();
      if (["input", "textarea", "select"].includes(tag) || t?.isContentEditable) return;
      const el = searchRef.current;
      if (!el) return;
      // Jangan curi fokus bila input tertutup modal/dialog atau tidak terlihat.
      const r = el.getBoundingClientRect();
      const top = r.width && document.elementFromPoint(r.left + r.width / 2, r.top + r.height / 2);
      if (!top || !(top === el || el.parentElement?.contains(top))) return;
      e.preventDefault(); el.focus();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  return (
    <div className="sq-filters" data-testid="mockup-queue-filters">
      {red > 0 && (
        <div className="sq-urgent-banner" data-testid="mockup-queue-urgent-banner">
          <AlertTriangle size={14}/>
          <span><b>{red}</b> pesanan mendesak yang masih perlu mockup (batas kirim &lt; 24 jam / terlambat)</span>
          {!urgentOnly ? (
            <button type="button" className="sq-link-btn" data-testid="mockup-queue-urgent-show"
              onClick={() => { setUrgentOnly(true); setCategory("all"); setTechnique("all"); setQInput(""); setSort("deadline"); }}>
              Lihat semua
            </button>
          ) : (
            <button type="button" className="sq-link-btn" data-testid="mockup-queue-urgent-clear"
              onClick={() => setUrgentOnly(false)}>Tampilkan semua</button>
          )}
        </div>
      )}
      <div className="sq-search-row">
        <label className="sq-search">
          <Search size={14}/>
          <input ref={searchRef} value={qInput} onChange={e => setQInput(e.target.value)}
            onKeyDown={e => { if (e.key === "Escape") setQInput(""); }}
            placeholder="Cari no. pesanan, pelanggan, produk, SKU  ( / )"
            data-testid="mockup-queue-search" inputMode="search"/>
          {qInput && (
            <button type="button" className="sq-icon-plain" onClick={() => setQInput("")}
              aria-label="Hapus pencarian" data-testid="mockup-queue-search-clear"><X size={14}/></button>
          )}
        </label>
        <select className="sq-sort" value={sort} onChange={e => setSort(e.target.value)} data-testid="mockup-queue-sort"
          aria-label="Urutkan">
          <option value="deadline">Batas kirim terdekat</option>
          <option value="newest">Pesanan terbaru</option>
          <option value="oldest">Pesanan terlama</option>
        </select>
        <button type="button" className={`sq-filter-btn${open || nActive ? " is-on" : ""}`} onClick={() => setOpen(v => !v)}
          aria-expanded={open} data-testid="mockup-queue-filter-toggle">
          <SlidersHorizontal size={14}/> Filter{nActive ? ` (${nActive})` : ""}
        </button>
      </div>
      {nActive > 0 && <div className="sq-active-filters" data-testid="mockup-queue-active-filters">
        {technique !== "all" && <button type="button" className="sq-active-chip" onClick={() => setTechnique("all")} data-testid="mockup-queue-active-tech">{techLabel} <X size={12}/></button>}
        {category !== "all" && <button type="button" className="sq-active-chip" onClick={() => setCategory("all")} data-testid="mockup-queue-active-cat">{catLabel} <X size={12}/></button>}
        <button type="button" className="sq-link-btn" onClick={() => { setTechnique("all"); setCategory("all"); }} data-testid="mockup-queue-filter-reset">Reset Filter</button>
      </div>}
      {open && <div className="sq-filter-panel" data-testid="mockup-queue-filter-panel">
      <div className="sq-chips sq-chips-tech" role="tablist" data-testid="mockup-queue-technique-chips">
        <span className="sq-chips-label">Teknik</span>
        <button type="button" className={`sq-chip${technique === "all" ? " is-active" : ""}`}
          onClick={() => setTechnique("all")} data-testid="mockup-queue-tech-all">
          Semua Pesanan <span className="sq-chip-n">{meta?.technique_all_count ?? 0}</span>
        </button>
        {(meta?.techniques || []).map(t => (
          <button key={t.key} type="button" className={`sq-chip${technique === t.key ? " is-active" : ""}`}
            onClick={() => setTechnique(t.key)} data-testid={`mockup-queue-tech-${t.key}`}>
            {t.label} <span className="sq-chip-n">{meta?.technique_counts?.[t.key] ?? 0}</span>
          </button>
        ))}
      </div>
      <div className="sq-chips" role="tablist" data-testid="mockup-queue-category-chips">
        <span className="sq-chips-label">Produk</span>
        <button type="button" className={`sq-chip${category === "all" ? " is-active" : ""}`}
          onClick={() => setCategory("all")} data-testid="mockup-queue-cat-all">
          Semua Produk <span className="sq-chip-n">{meta?.all_count ?? 0}</span>
        </button>
        {cats.map(c => (
          <button key={c.key} type="button" className={`sq-chip${category === c.key ? " is-active" : ""}`}
            onClick={() => setCategory(c.key)} data-testid={`mockup-queue-cat-${c.key}`}>
            {c.label} <span className="sq-chip-n">{counts[c.key] ?? 0}</span>
          </button>
        ))}
      </div>
      </div>}
      {meta?.search_ignores_category && (
        <p className="sq-note" data-testid="mockup-queue-search-note">Pencarian mencakup semua teknik dan kategori.</p>
      )}
    </div>
  );
}
